export const colors = {
  white: '#FFF',
  black: '#000',

  frameworkColor: '#70C2C4',
  cultureColor: '#453A9A',
  publicProject: '#B26BF5',
  privateProject: '#5FCFDA',
  teammate: '#C9DEFC',
  orgAdmin: '#DDD3FB',

  coralDefault: '#FE7D6A',
  orangeDefault: '#FFC06A',

  lightPale: '#FBF4EC',
  darkPale: '#EDDDD2',

  statusOrange: '#FB6D00',
  statusGreen: '#37C597',
  statusRed: '#ED4F55',
  statusYellow: '#FFB900',
  statusBlue: '#659DFF',

  darkBlue: '#2C2A43',

  veryLightGrey: '#F3F4F7',
  lightGrey: '#D7DAE3',
  darkGrey: '#807F8E',

  liteLilac: '#8B88A8',
  darkLilac: '#5E5B76',
};

export const palette = {
  text: {
    primary: colors.darkBlue,
    secondary: colors.white,
    disabled: colors.white,
  },
  primary: {
    light: colors.coralDefault,
    main: colors.coralDefault,
    dark: colors.coralDefault,
    contrastText: colors.white,
  },
  secondary: {
    light: colors.orangeDefault,
    main: colors.orangeDefault,
    dark: colors.orangeDefault,
    contrastText: colors.white,
  },
  error: {
    light: colors.statusRed,
    main: colors.statusRed,
    dark: colors.statusRed,
    contrastText: colors.white,
  },
  warning: {
    light: colors.statusYellow,
    main: colors.statusYellow,
    dark: colors.statusYellow,
    contrastText: colors.white,
  },
  info: {
    light: colors.statusBlue,
    main: colors.statusBlue,
    dark: colors.statusBlue,
    contrastText: colors.white,
  },
  success: {
    light: colors.statusGreen,
    main: colors.statusGreen,
    dark: colors.statusGreen,
    contrastText: colors.white,
  },
  colors,
};
